// RESULTS
export const FETCH_RESULTS = 'FETCH_RESULTS';
export const FETCH_INITIAL_RESULTS = 'FETCH_INITIAL_RESULTS';
export const ADD_RESULTS = 'ADD_RESULTS';
export const ADD_INITIAL_RESULTS = 'ADD_INITIAL_RESULTS';
export const ADD_RESULTS_FAILED = 'ADD_RESULTS_FAILED';

export const FETCH_MAKES = 'FETCH_MAKES';
export const ADD_MAKES = 'ADD_MAKES';
export const ADD_MAKES_FAILED = 'ADD_MAKES_FAILED';

export const FETCH_LISTING = 'FETCH_LISTING';
export const ADD_LISTING = 'ADD_LISTING';
export const ADD_LISTING_FAILED = 'ADD_LISTING_FAILED';

export const CHECK_POSTCODE = 'CHECK_POSTCODE';
export const FETCH_POSTCODE = 'FETCH_POSTCODE';
export const ADD_POSTCODE = 'ADD_POSTCODE';
export const RESET_POSTCODE = 'RESET_POSTCODE';
export const ADD_POSTCODE_FAILED = 'ADD_POSTCODE_FAILED';
export const ADD_POSTCODE_RESULT = 'ADD_POSTCODE_RESULT';
export const ADD_POSTCODE_RESULT_FAILED = 'ADD_POSTCODE_RESULT_FAILED';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export const GET_VIEWPORT = 'GET_VIEWPORT';

export const FETCH_SHORTLIST = 'FETCH_SHORTLIST';
export const UPDATE_SHORTLIST = 'UPDATE_SHORTLIST';
export const UPDATE_SHORTLIST_FAILED = 'UPDATE_SHORTLIST_FAILED';

export const FETCH_POPULAR_RESULTS = 'FETCH_POPULAR_RESULTS';
export const ADD_POPULAR_RESULTS_FAILED = 'ADD_POPULAR_RESULTS_FAILED';
export const ADD_POPULAR_RESULTS = 'ADD_POPULAR_RESULTS';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js